module.exports = __webpack_public_path__ + "static/media/cluster_5.5975040d.webp";